import React from "react";
import { View } from "react-native";

type DashboardProps = {
  color?: string;
};

const DashboardIcon: React.FC<DashboardProps> = ({ color = "#000" }) => {
  return (
    <View>
      <svg
        width="23"
        height="22"
        viewBox="0 0 23 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          clipPath="url(#clip0_14342_3731)"
          transform="translate(0.5, 0.5)" /* Shift slightly right and down */
        >
          <path
            d="M4.54832 13.2584C5.60128 12.1586 7.27817 11.2511 9.26335 11.2511C10.64145 11.2511 11.90209 11.6986 12.9593 12.4373"
            stroke="#17191D"
            strokeWidth="1.53"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.32987 17.197H2.32987C1.8962 17.197 1.4837 17.011 1.20628 16.7336C0.928861 16.4562 0.742859 16.0437 0.742859 15.61V2.68479C0.742859 2.25113 0.928861 1.83863 1.20628 1.56121C1.4837 1.28379 1.8962 1.09778 2.32987 1.09778H16.0437C16.4774 1.09778 16.8899 1.28379 17.1673 1.56121C17.4447 1.83863 17.6307 2.25113 17.6307 2.68479V7.63651"
            stroke="#17191D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.26305 8.829C10.6506 8.829 11.7697 7.70993 11.7697 6.32239C11.7697 4.93485 10.6506 3.81578 9.26305 3.81578C7.87551 3.81578 6.75644 4.93485 6.75644 6.32239C6.75644 7.70993 7.87551 8.829 9.26305 8.829Z"
            stroke="#17191D"
            strokeWidth="1.53"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.187 17.0483C11.6412 16.9737 11.6412 16.1366 12.187 16.062C14.2819 15.6787 15.9203 14.3995 16.3754 12.3398L16.4093 12.1847C16.5298 11.6254 17.3349 11.6221 17.4749 12.181L17.5177 12.3616C18.0088 14.2421 19.6473 15.6784 21.7198 16.061C22.2706 16.1356 22.2706 16.9732 21.7198 17.0478C19.6473 17.4304 18.0088 18.8667 17.5177 20.7472L17.4749 20.9278C17.3349 21.4867 16.5298 21.4834 16.4093 20.9242L16.3754 20.7691C15.9203 18.7093 14.2819 17.43 12.187 17.0483Z"
            stroke="#17191D"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_14342_3731">
            <rect width="23" height="22" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </View>
  );
};

export default DashboardIcon;
